import { useState } from 'react'
import CommonModal from '../../ResetContext/components/DumpModal'
import { Button } from '@mui/material'
import { useAddBalance } from '../../../../../queries/billing'

const AddBalanceModal = ({ isOpen, onClose, userActiveLocation, saveActiveLocation }) => {
    const [input, setInput] = useState(1)
    const [loading, setLoading] = useState(false)
    const addBalance = useAddBalance();

    const handleSubmit = async () => {
        setLoading(true);
        const payload = {
            Balance: input,
            type: "credit",
            agency_id: userActiveLocation?.agency_id,
            account_id: userActiveLocation?._id,
            customer_id: userActiveLocation?.customer_id
        };

        const response = await addBalance.mutateAsync(payload);
        if (response) {
            if (response.PaymentDone) {
                const payload = {
                    payment_confirm: "success",
                    Balance: input,
                    type: "credit",
                    agency_id: userActiveLocation?.agency_id,
                    logs_id: response.Balance_logs._id,
                    account_id: userActiveLocation?._id,
                    customer_id: userActiveLocation?.customer_id

                };
                const updatedata = await addBalance.mutateAsync(payload);
                if (updatedata.success) {
                    saveActiveLocation(updatedata.data);
                    onClose();
                }
            } else {
                onClose()
            }
        }
    };
    return (
        <CommonModal isOpen={isOpen} onClose={onClose} showAlert={false} title='Add Balance'>
            <div className='flex flex-col'>
                <label htmlFor="" className='mb-1'>Amount</label>
                <input type="number" value={input} onChange={(e) => setInput(e.target.value)} placeholder='Amount' className='px-3 py-2 border !border-border rounded-lg !outline-none' />
                <div className='mt-3 flex justify-end gap-2'>
                    <Button variant="outlined" color='error' className='!bg-card !text-destructive !normal-case' onClick={onClose}>Close</Button>
                    <Button variant="outlined" sx={{ border: "1px solid hsl(var(--border))", color: "hsl(var(--foreground))" }} className='!normal-case hover:!border hover:!border-border' disabled={loading} onClick={handleSubmit}>{loading ? "wait..." : 'Add'}</Button>
                </div>
            </div>
        </CommonModal>
    )
}

export default AddBalanceModal